import { useEffect, useRef } from 'react'
import { useInView, animate } from 'framer-motion'
import { Legacy_CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'
import { Props_SnippetStatisticsPercent } from './StatisticsPercent.props'

const AnimatedNumber = ({ value }: { value: number }) => {
    const ref = useRef<HTMLSpanElement>(null)
    const inView = useInView(ref, { once: true })

    useEffect(() => {
        if (!inView || !ref.current) return

        const controls = animate(0, value, {
            duration: 5,
            ease: 'easeInOut',
            onUpdate(latest) {
                if (ref.current) {
                    ref.current.textContent = Math.round(latest).toLocaleString()
                }
            },
        })

        return () => controls.stop()
    }, [inView, value])

    return <span ref={ref}>0</span>
}

const StatisticsPercent = (props: Props_SnippetStatisticsPercent) => {
    const { snippet, heading, repeatable_entries } = props

    const classHeadingVisibility: string = heading.visibility.value ? `snippet-statistics__heading--${heading.visibility.value}` : ''
    const classSnippetTheme = `snippet-statistics--theme-${snippet.theme?.value}`

    const ref = useRef<HTMLDivElement>(null)
    const inView = useInView(ref, { once: true })

    return (
        <section className={`snippet-statistics ${classSnippetTheme}`}>
            <div className="snippet-statistics__container">
                <h2 className={`snippet-statistics__heading ${classHeadingVisibility}`}>{heading.content.value}</h2>
                <div className="snippet-statistics__container-entries">
                    {repeatable_entries.map((stat, index) => (
                        <div className={`snippet-statistics__entry snippet-statistics__entry--${index + 1}`} key={index}>
                            <div className={`snippet-statistics__entry-container-statistic ${inView ? 'snippet-statistics__entry-container-statistic--playing' : ''}`} ref={ref}>
                                { stat.statistic?.value && (
                                    <>
                                        <svg viewBox="0 0 36 36" className="snippet-statistics__entry-statistic-percent">
                                            <path className="snippet-statistics__entry-statistic-percent-background" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                            <path className="snippet-statistics__entry-statistic-percent-value" strokeDasharray={`${stat.statistic.value}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                                        </svg>
                                        <span className="snippet-statistics__entry-statistic-percent-content"><AnimatedNumber value={parseInt(stat.statistic.value)} />%</span>
                                    </>
                                )}
                            </div>
                            {stat.content?.value && <div className="snippet-statistics__entry-content">{Legacy_CompileMarkdown(stat.content.value)}</div>}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default StatisticsPercent